import React from "react";
import { ToastDanger } from "utils/toast/Toast";
import * as Sentry from "@sentry/react";
import { isDevelopment } from "utils/other/Environment";
import {logout} from "utils/auth/auth";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log(error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    if (isDevelopment()) {
      return this.props.children;
    }

    const lastError = new Date(localStorage.getItem("error_reload_at"));
    // if last error was less than 1 minutes ago, clear local storage and reload
    if (new Date() - lastError < 60 * 1000) {
      logout();
      localStorage.setItem("error_reload_at", new Date());
      ToastDanger("مشکلی رخ داده است. لطفا مجددا لاگین کنید.");
    } else {
      ToastDanger("مشکلی رخ داده است. لطفا دوباره تلاش کنید.");
    }
    
    // reload after 3 seconds
    setTimeout(() => {
      window.location.reload();
    }, 3000);

    return Sentry.withErrorBoundary(this.props.children);
  }
}

export default ErrorBoundary;
